import Cookies from 'js-cookie';

const requestHeaderNames = {
  appVersion: 'X-CVNA-AppVersion',
  bcid: 'X-CVNA-BrowserCookieId',
  deviceId: 'X-CVNA-DeviceId',
  deviceType: 'X-CVNA-DeviceType',
  platform: 'X-CVNA-Platform'
};

const createMobileRequestHeaders = () => {
  const headers = {};

  return Object.values(requestHeaderNames).reduce((headers, headerName) => {
      headers[headerName] = Cookies.get(headerName);

    return headers;
  }, headers);
};

const setDeviceType = () => {
  const device = JSON.parse(localStorage.getItem('deviceInformation'));

  if (+device?.isBrowser) {
    return 'Desktop';
  }

  if (+device?.isTablet) {
    return 'Tablet';
  }

  if (+device?.isMobilePhone) {
    return 'Mobile';
  }

  return 'Other';
};

const createWebRequestHeaders = () => {
  const headers = requestHeaderNames;

  return {
    [headers.appVersion]: '',
    [headers.bcid]: Cookies.get('BrowserCookieId'),
    [headers.deviceId]: '',
    [headers.deviceType]: setDeviceType(),
    [headers.platform]: 'Web'
  };
};

export const checkForMobileCookies = (mobileHeaders=createMobileRequestHeaders()) => {
  const { appVersion, platform } = requestHeaderNames;

  return mobileHeaders?.[appVersion] !== undefined ||
    mobileHeaders?.[platform] !== undefined;
};

export const getRequestHeaders = () => {
  const mobileHeaders = createMobileRequestHeaders();

  return (checkForMobileCookies(mobileHeaders)) ? mobileHeaders : createWebRequestHeaders();
};